import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { I18nextProvider } from 'react-i18next'
import { RouterProvider } from 'react-router-dom'
import ToastComponent from './components/common/ToastComponent'
import LoadingComponent from './components/common/LoadingComponent'
import { router } from './router/routes'
import i18n from './i18n'
import { store } from './store'
import reportWebVitals from './reportWebVitals'

import './index.scss'

/*if (process.env.NODE_ENV === 'development') {
  const { worker } = require('./mocks/browser')
  worker.start()
}*/

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <LoadingComponent />
      <ToastComponent />
      <RouterProvider router={router} />
    </I18nextProvider>
  </Provider>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
